import React, { useState } from 'react';
import { Box, Button, Grid, Typography, Dialog, DialogContent, TextField } from '@mui/material';
import buttonStyle from '../../../styles/buttonStyle';
import AddIcon from '@mui/icons-material/Add';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { DataGrid,GridColumnMenu  } from '@mui/x-data-grid';
import dataGridStyle from '../../../styles/dataGridStyle';
 
const initialCustomerData = {
  Part_Code: '',
  Description: '',
  Category: '',
  UOM: '',
  Cost: '',
  MRP: '',
  Tax_Code: '',
  Location: '',
  Opening: '',
  Current: '',
 };

function CustomColumnMenu(props) {
  return (
    <GridColumnMenu
      {...props}
      slots={{
       columnMenuColumnsItem: null,
      columnMenuSortItem: null,
      }}
    />
    );
}

function SpareParts() {
  const [isAddDialogOpen, setAddDialogOpen] = useState(false);
  const [isEditDialogOpen, setEditDialogOpen] = useState(false);
  const [newCustomerData, setNewCustomerData] = useState(initialCustomerData);
  const [editCustomerData, setEditCustomerData] = useState(initialCustomerData);
  const [selectedRow, setSelectedRow] = useState(null); // Declare it only once
   const [rows, setRows] = useState([
     { id: 1, Part_Code: 'Lb0001', Description: 'Engine Oil', Category: 'Lubricant', UOM: 'Ltrs', Cost: '125', MRP: '185' ,Tax_Code: '20', Location: 'Lube room', Opening: '150', Current: '20' },
    { id: 2, Part_Code: 'CS0001', Description: 'Cotton Waste', Category: 'Consumable', UOM: 'Kgs', Cost: '50', MRP: '85',Tax_Code: '20', Location: 'Front side', Opening: '5', Current: '2.5'  },
    { id: 3, Part_Code: 'Lb0002', Description: 'Gear Oil', Category: 'Lubricant', UOM: 'Ltrs', Cost: '245', MRP: '325' ,Tax_Code: '20', Location: 'Lube room', Opening: '75', Current: '50' },
    { id: 4, Part_Code: 'GS0001', Description: 'Grease', Category: 'Lubricant', UOM: 'Kgs', Cost: '145', MRP: '215',Tax_Code: '20', Location: 'Front side', Opening: '7', Current: '5.5'  },
    { id: 5, Part_Code: 'BB0001', Description: 'Bulb 1.5V', Category: 'Accessories', UOM: 'Nos', Cost: '15', MRP: '25' ,Tax_Code: '20', Location: 'Desk1', Opening: '150', Current: '45' },
    { id: 6, Part_Code: 'FT001', Description: 'Oil Filter', Category: 'Spareparts', UOM: 'Nos', Cost: '245', MRP: '375',Tax_Code: '20', Location: 'Desk2', Opening: '25', Current: '5'  },
    { id: 7, Part_Code: 'DF001', Description: 'Diesel Filter', Category: 'Spareparts', UOM: 'Nos', Cost: '425', MRP: '545' ,Tax_Code: '20', Location: 'Desk3', Opening: '15', Current: '0' },
    { id: 8, Part_Code: 'BK001', Description: 'Break Oil', Category: 'Lubricant', UOM: 'Ltrs', Cost: '245', MRP: '325',Tax_Code: '20', Location: 'Oil Room', Opening: '5', Current: '1.5'  },
  ]);

 
   const handleAddDialogOpen = () => {
    setAddDialogOpen(true);
  };

  const handleAddDialogClose = () => {
    setAddDialogOpen(false);
  };

  const handleEditDialogOpen = (row) => {
    setSelectedRow(row); // Set the selected row here
    setEditCustomerData(row);
    setEditDialogOpen(true);
  };
  
  
  

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
  };

  const handleSaveCustomer = () => {
    setRows([...rows, { id: rows.length + 1, ...newCustomerData }]);
    setNewCustomerData(initialCustomerData);
    setAddDialogOpen(false);
  };

  const handleSaveEdit = () => {
    if (selectedRow !== null) {
      const updatedRows = rows.map((row) =>
        row.id === selectedRow.id ? editCustomerData : row
      );
      setRows(updatedRows);
    }
    setEditDialogOpen(false);
  };
  
  
  
  const handleDelete = (customerId) => {
    const updatedRows = rows.filter((row) => row.id !== customerId);
    setRows(updatedRows);
  };
  
  


const columns = [
  
  {
    field: 'id',  
    headerName: 'ID',
    sortable: false,
    flex: 1,
    minWidth: 100,
    hide: true, 
  },
  { field: 'Part_Code', headerName: 'PartCode', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Description', headerName: 'Description', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Category', headerName: 'Category', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'UOM', headerName: 'UOM', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Cost', headerName: 'Cost', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'MRP', headerName: 'MRP', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Tax_Code', headerName: 'TaxCode', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Location', headerName: 'Location', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Opening', headerName: 'Opening', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Current', headerName: 'Current', editable: false, sortable: false, flex: 1, minWidth: 100 },
  {
    field: 'action',
    headerName: 'Actions',
    sortable: false,
    flex: 1,
    minWidth: 180,
    renderCell: (params) => (
      <div>
        <Button
           size="small"
          startIcon={<ModeEditOutlineOutlinedIcon sx={{ color: '#0d47a1'}}/>}
          onClick={() => handleEditDialogOpen(params.row)}
        >
         </Button>
        <Button
          size="small"
          startIcon={<DeleteOutlineOutlinedIcon sx={{ color: '#b71c1c'}}/>}
          onClick={() => handleDelete(params.row.id)}
        >
         </Button>
      </div>
    ),
  },
];


return (
  <Box mt={2}>
    <Grid container spacing={1}>
    <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>SPAREPARTS DETAILS</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end'>
          <Button sx={buttonStyle.root}  onClick={handleAddDialogOpen}><AddIcon />Add SpareParts</Button>
            </Grid>
            </Grid>
            </Grid>
      <Grid item xs={12} mt={1}>
        <Box sx={dataGridStyle.root}>
        <DataGrid
  columnHeaderHeight={42}
  rowHeight={40}
  rows={rows}
  columns={columns}
  getRowId={(row) => row.id}
  initialState={{
    pagination: {
      pageSize: 10,
    },
  }}
  slots={{ columnMenu: CustomColumnMenu }}
  disableRowSelectionOnClick
/>
         </Box>
      </Grid>
    </Grid>


    <Dialog open={isAddDialogOpen} onClose={handleAddDialogClose}>
        <DialogContent>
        <Grid container justifyContent="center" alignItems="center" direction="column">
      <Typography variant="h6" align="center">
        <b>Add SpareParts</b>
      </Typography>
    </Grid>
        <Grid container spacing={2} mt="25px">
      <Grid item xs={6}>
        <TextField
          label="PartCode"
          fullWidth
          value={newCustomerData.Part_Code}
          onChange={(e) => setNewCustomerData({ ...newCustomerData, Part_Code: e.target.value })}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Description"
          fullWidth
          value={newCustomerData.Description}
          onChange={(e) => setNewCustomerData({ ...newCustomerData, Description: e.target.value })}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Category"
          fullWidth
          value={newCustomerData.Category}
          onChange={(e) => setNewCustomerData({ ...newCustomerData, Category: e.target.value })}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="UOM"
          fullWidth
          value={newCustomerData.UOM}
          onChange={(e) => setNewCustomerData({ ...newCustomerData, UOM: e.target.value })}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Cost"
          fullWidth
          value={newCustomerData.Cost}
          onChange={(e) => setNewCustomerData({ ...newCustomerData, Cost: e.target.value })}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="MRP"
          fullWidth
          value={newCustomerData.MRP}
          onChange={(e) => setNewCustomerData({ ...newCustomerData, MRP: e.target.value })}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="TaxCode"
          fullWidth
          value={newCustomerData.Tax_Code}
          onChange={(e) => setNewCustomerData({ ...newCustomerData, Tax_Code: e.target.value })}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Location"
          fullWidth
          value={newCustomerData.Location}
          onChange={(e) => setNewCustomerData({ ...newCustomerData, Location: e.target.value })}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Opening"
          fullWidth
          value={newCustomerData.Opening}
          onChange={(e) => setNewCustomerData({ ...newCustomerData, Opening: e.target.value })}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Current"
          fullWidth
          value={newCustomerData.Current}
          onChange={(e) => setNewCustomerData({ ...newCustomerData, Current: e.target.value })}
        />
      </Grid>
    </Grid>

    <Grid container justifyContent="flex-end" alignItems="flex-end">
          <Button 
          sx={{ backgroundColor: 'transparent', border: '1px solid #4CAF50', color: '#4CAF50' , marginTop: '10px',marginRight: '10px'}}
          onClick={handleSaveCustomer}>ADD
          </Button>

          <Button
          sx={{ backgroundColor: 'transparent',border: '1px solid #f44336', color: '#f44336', marginTop: '10px',  }}
           onClick={handleAddDialogClose}>CANCEL
          </Button>
    </Grid>


        </DialogContent>
      </Dialog>


      <Dialog open={isEditDialogOpen} onClose={handleEditDialogClose}>
        <DialogContent>
        <Grid container justifyContent="center" alignItems="center" direction="column">
      <Typography variant="h6"  >
       <b>Edit SpareParts</b> 
      </Typography>
    </Grid>
        <Grid container   spacing={2} mt="25px">
      <Grid item xs={6}>
           <TextField
            label="PartCode"
            fullWidth
            value={editCustomerData.Part_Code}
            onChange={(e) => setEditCustomerData({ ...editCustomerData, Part_Code: e.target.value })}
          />
           </Grid>
           <Grid item xs={6}>

          <TextField
            label="Description"
            fullWidth
            value={editCustomerData.Description}
            onChange={(e) => setEditCustomerData({ ...editCustomerData, Description: e.target.value })}
          />
                </Grid>
                <Grid item xs={6}>

          <TextField
          label="Category"
          fullWidth
          value={editCustomerData.Category}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, Category: e.target.value })}
        />
              </Grid>
              <Grid item xs={6}>

        <TextField
          label="UOM"
          fullWidth
          value={editCustomerData.UOM}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, UOM: e.target.value })}
        />
              </Grid>
              <Grid item xs={6}>

        <TextField
          label="Cost"
          fullWidth
          value={editCustomerData.Cost}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, Cost: e.target.value })}
        />
              </Grid>
      <Grid item xs={6}>

        <TextField
          label="MRP"
          fullWidth
          value={editCustomerData.MRP}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, MRP: e.target.value })}
        />
        </Grid>
        <Grid item xs={6}>

        <TextField
          label="TaxCode"
          fullWidth
          value={editCustomerData.Tax_Code}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, Tax_Code: e.target.value })}
        />
        </Grid>
        <Grid item xs={6}>

        <TextField
          label="Location"
          fullWidth
          value={editCustomerData.Location}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, Location: e.target.value })}
        />
        </Grid>
        <Grid item xs={6}>

        <TextField
          label="Opening"
          fullWidth
          value={editCustomerData.Opening}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, Opening: e.target.value })}
        />
        </Grid>
        <Grid item xs={6}>

        <TextField
          label="Current"
          fullWidth
          value={editCustomerData.Current}
          onChange={(e) => setEditCustomerData({ ...editCustomerData, Current: e.target.value })}
        />
        </Grid>
        </Grid>

        <Grid container justifyContent="flex-end" alignItems="flex-end">
   
    <Button
      sx={{ backgroundColor: 'transparent', border: '1px solid #4CAF50', color: '#4CAF50' , marginTop: '10px',marginRight: '10px'}}
      onClick={handleSaveEdit}
    >
      UPDATE
    </Button>
    <Button
      sx={{ backgroundColor: 'transparent',border: '1px solid #f44336', color: '#f44336', marginTop: '10px',  }}
      onClick={handleEditDialogClose}
    >
     CANCEL
    </Button>
  </Grid>
        </DialogContent>
      </Dialog>

</Box>
)
}

export default SpareParts